import { createCommand } from '../../utils';
import { filterUpdated, moduleName } from '../state';
import type { RoadSectionFilter } from '../../domain/Reference';

const FilterReferenceCommand = createCommand(
    `${moduleName}/FILTER_REFERENCE`,
    async (filter: RoadSectionFilter, { dispatch, extra }) => {
        extra.externalReferenceConfiguration.saveRoadSectionsFilter(filter);
        dispatch(filterUpdated(filter));
    },
);

export default FilterReferenceCommand;
